import CardList from './card-list';

export default CardList;